import LeadTrialSection from './LeadTrialSection'

export default function TrialSignup() {
  return <LeadTrialSection sectionId="testar-gratis" />
}
